var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReceivableCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#F4F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3333 43.3334C43.3333 44.0694 42.7347 44.6667 42 44.6667H26C25.2653 44.6667 24.6667 44.0694 24.6667 43.3334V28.6667C24.6667 27.9307 25.2653 27.3334 26 27.3334V28.6667C26 30.1374 27.196 31.3334 28.6667 31.3334H39.3333C40.804 31.3334 42 30.1374 42 28.6667V27.3334C42.7347 27.3334 43.3333 27.9307 43.3333 28.6667V43.3334ZM28.6667 23.3334L39.3333 23.3374V24.6667V28.6667H28.6667V24.6667V23.3334ZM42 24.6667V23.3334C42 21.8627 40.804 20.6667 39.3333 20.6667H28.6667C27.196 20.6667 26 21.8627 26 23.3334V24.6667C23.7947 24.6667 22 26.4614 22 28.6667V43.3334C22 45.5387 23.7947 47.3334 26 47.3334H42C44.2053 47.3334 46 45.5387 46 43.3334V28.6667C46 26.4614 44.2053 24.6667 42 24.6667Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReceivableCircle);
export default __webpack_public_path__ + "static/media/IconReceivableCircle.cb0e01413d137474923ac9c32a010fa9.svg";
export { ForwardRef as ReactComponent };